import { render, staticRenderFns } from "./ItemsContainerMixin.vue?vue&type=template&id=a4e59986"
import script from "./ItemsContainerMixin.vue?vue&type=script&lang=js"
export * from "./ItemsContainerMixin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports